"use strict";

const ingredientItems = document.querySelectorAll(".ingredients__item");
const ingredientCards = document.querySelectorAll(".ingredients__card");
const ingredientHints = document.querySelectorAll(
  ".ingredients__hint--desktop, .ingredients__hint--mobile"
);

if (ingredientItems.length > 0 && ingredientCards.length > 0) {
  function activateIngredient(ingredient) {
    ingredientItems.forEach((item) => item.classList.remove("is-active"));
    ingredientCards.forEach((card) => card.classList.remove("is-active"));
    ingredientHints.forEach((hint) => hint.classList.add("is-hidden"));

    document
      .querySelector(`[data-ingredient="${ingredient}"]`)
      ?.classList.add("is-active");

    document
      .querySelector(`[data-card="${ingredient}"]`)
      ?.classList.add("is-active");
  }

  function resetIngredients() {
    ingredientItems.forEach((item) => item.classList.remove("is-active"));
    ingredientCards.forEach((card) => card.classList.remove("is-active"));
    ingredientHints.forEach((hint) => hint.classList.remove("is-hidden"));
  }

  ingredientItems.forEach((item) => {
    const ingredient = item.dataset.ingredient;

    item.addEventListener("mouseenter", () => {
      activateIngredient(ingredient);
    });

    item.addEventListener("mouseleave", () => {
      resetIngredients();
    });

    item.addEventListener("click", () => {
      activateIngredient(ingredient);
    });
  });
}